import { makeStyles } from '@material-ui/styles';
import { useTranslation } from '@tools/i18n';
import { ShopwareUuid } from '@services/types/Shopware';
import { useState } from 'react';

const useStyles = makeStyles({
    image: {
        position: 'relative',
        maxWidth: '100%',
        height: 'auto',
        '& img': {
            height: 'auto',
            width: '100%',
            maxWidth: '100%',
        },
        '&:after': {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            position: 'absolute',
            boxShadow: 'inset 0 0 90px 8px #f3f3f5',
            mixBlendMode: 'multiply',
            pointerEvents: 'none',
        },
        '& .has-error': {
            opacity: 0,
        },
    },
}, { name: 'np-image' });

interface PropTypes {
    productUuid: ShopwareUuid;
    alt: string;
    size?: 'square-200' | 'square-500',
    className?: string;
}

export default function MyNewportImage(
    {
        productUuid, alt,
        size = 'square-200',
        className = '',
    }: PropTypes,
): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    const [error, setError] = useState(false);

    return <div className={`${classes.image} ${className}`}>
        <img
            alt={alt}
            src={`https://my.newport.se/images/product/${productUuid}/main/${size}`}
            className={error ? 'has-error' : ''}
            onError={(e) => setError(true)}
        />
    </div>;
}
